<template>
    <div class="main">
        <img src="../assets/contact/background_0.webp" alt="" class="background">
        <div class="contentAndBackgroundWrap">
            <div class="contentWrap">
                <div class="companyName">Allvita Animal Health Pty Ltd</div>
                <div class="contactWrap">
                    <img class="icon" src="../assets/contact/icon_0.webp" alt="">
                    <div class="text">ACN 625 603 876</div>
                </div>
                <div class="contactWrap">
                    <img class="icon" src="../assets/contact/icon_1.webp" alt="">
                    <div class="text">info@allvita.com.au</div>
                </div>
            </div>
            <img class="background_1" src="../assets/contact/background_1.webp" alt="">
        </div>
        
        <page-footer style="z-index: 8; position: fixed; bottom: 0; left: 0;"></page-footer>
    </div>
</template>

<script>
import PageFooter from "./PageFooter.vue";

export default {
    components: {
            PageFooter,
        },
}
</script>

<style lang="scss" scoped>
.main {
    padding-top: $navBarHeight;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;

    .background {
        width: 100%;
        height: auto;
    }

    .contentAndBackgroundWrap {
        display: flex;
        flex-direction: row;
        align-items: flex-start;
        justify-content: space-between;
        margin-top: 9rem;
        margin-bottom: 12rem;
        width: 100%;
        padding: 0 7% 0 17%;

        .contentWrap {
            display: flex;
            flex-direction: column;
            margin-top: 5rem;

            .companyName {
                font-size: 1.8rem;
                font-family: "Montserrat", serif;
                font-weight: 700;
                color: #3D3D3D;
            }

            .contactWrap {
                margin-top: 2rem;
                display: flex;
                flex-direction: row;
                align-items: center;

                .icon {
                    width: 1.3rem;
                    height: auto;
                }

                .text {
                    font-size: 1.1rem;
                    font-family: "Montserrat", serif;
                    font-weight: 500;
                    color: #3D3D3D;
                    margin-left: 1rem;
                }
            }
        }

        .background_1 {
            width: 60%;
            height: auto;
        }
    }

    
}

@media (max-width: 768px) {
    .main {
        padding-top: 4rem;

        .contentAndBackgroundWrap {
            flex-direction: column;
            padding: 0 1.5rem;
            margin-top: 2rem;
            margin-bottom: 5rem;
            width: 100%;
            align-items: center;
            
            .contentWrap {
                margin-top: 2rem;
                order: 2;
                width: 100%;
                
                .companyName {
                    font-size: 1.4rem;
                }
                
                .contactWrap {
                    margin-top: 1.5rem;
                    
                    .text {
                        font-size: 1rem;
                    }
                }
            }
            
            .background_1 {
                width: 100%;
                height: auto;
                order: 1;
                margin-top: 1rem;
            }
        }
    }
}
</style>